export default __webpack_public_path__ + "static/UpKeep_Feature@2x-d036c046c1e1e066da62e77cfb8299b5.png";